import { SafeUrl } from '@angular/platform-browser';

export type FileError = 'errorType' | 'errorSize';


export class Message {
  owner?: string;
  name?: string;
  text?: string;
  img?: SafeUrl;
  fileName?: string;
  doc?: string;
  color?: string;
  type?: string;
  id?: number;
  attendantId?: string;
  urlBlob?: SafeUrl;
}

export interface MessageRawData {
  name: string;
  data: string;
}
export interface FileData {
  chunks: Array<string>;
  type: string;
  name: string;
  result?: string | ArrayBuffer;
}
